import api from "./api";
import navigation from "./navigation";
import listSearch from "./listSearch";

const PATH = api;

export {PATH, navigation, listSearch};